import React, { FC, memo } from "react";

const DownloadRow: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.66669V9.33335M8 9.33335L10.6667 6.66669M8 9.33335L5.33333 6.66669"
      stroke="#495A64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 10V12.6667C3.33333 13.0349 3.63181 13.3334 4 13.3334H12C12.3682 13.3334 12.6667 13.0349 12.6667 12.6667V10"
      stroke="#495A64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(DownloadRow);
